<template>
  <div class="medal-manager">
    <!-- 标签页 -->
    <el-tabs
      v-model="filters.medalType"
      type="card"
      style="margin-bottom: 20px"
      @tab-click="handleClick"
    >
      <el-tab-pane label="学习勋章" name="1"></el-tab-pane>
      <el-tab-pane label="答题勋章" name="6"></el-tab-pane>
      <el-tab-pane label="分享勋章" name="4"></el-tab-pane>
      <el-tab-pane label="拉新勋章" name="3"></el-tab-pane>
      <el-tab-pane label="消费勋章" name="2"></el-tab-pane>
      <el-tab-pane label="赚钱勋章" name="5"></el-tab-pane>
    </el-tabs>
    <!-- 操作按钮组 -->
    <el-form :inline="true">
      <el-form-item>
        <toolbar
          :buttonList="buttonList"
          @callFunction="callFunction"
        ></toolbar>
      </el-form-item>
       <el-form-item>
      </el-form-item>
    </el-form>

    <!-- 勋章配置表格 -->
    <el-table
      :data="tableData"
      border
      stripe
      highlight-current-row=""
      @current-change="selectCurrentRow"
      style="width: 100%; margin-top: 20px"
      :cell-style="{ 'text-align': 'center' }"
      :header-cell-style="{ 'text-align': 'center' }"
      class="custom-padding-table"
    >
      <!-- 等级列 -->
      <el-table-column prop="grade" label="等级"/>
      <!-- 勋章名称列 -->
      <el-table-column prop="medalName" label="勋章名称" />
      <!-- 获取条件列 -->
      <el-table-column
        v-if="filters.medalType == 1"
        label="获取条件 (看视频时长:x分钟)"
        prop="conditionValue"
      >
      </el-table-column>
      <el-table-column
        v-if="filters.medalType == 2"
        label="获取条件 (消费金额:元)"
      >
      <template #default="scope">
          {{scope.row.conditionValue/100}}

      </template>
      </el-table-column>
      <el-table-column
        v-if="filters.medalType == 3"
        label="获取条件 (拉新人数:个)"
        prop="conditionValue"
      >
      </el-table-column>
      <el-table-column
        v-if="filters.medalType == 4"
        label="获取条件 (分享有效点击:次)"
        prop="conditionValue"
      >
      </el-table-column>
      <el-table-column
        v-if="filters.medalType == 5"
        label="获取条件 (赚钱金额:元)"
        prop="conditionValue"
      >
      </el-table-column>
      <el-table-column
        v-if="filters.medalType == 6"
        label="获取条件 (答对题数:个)"
        prop="conditionValue"
      >
      </el-table-column>
      <!-- 材质列 -->
      <el-table-column prop="rankTexture" label="材质"  />
      <!-- 勋章图片列 -->
      <el-table-column label="勋章图片">
        <template #default="scope">
          <el-image
            v-if="scope.row.medalImgUrl"
            :src="scope.row.medalImgUrl"
            style="width: 60px; height: 60px;"
            fit="scale-down" 
            
          />
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" >
        <template slot-scope="scope">
          <el-button
            @click="jumpRevisionHistory(scope.row)"
            type="text"
            size="small"
            >修改记录</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!--底部工具条-->
    <el-col :span="24" class="pageBar">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pages.pageIndex"
        :page-sizes="pages.pageArr"
        :page-size="pages.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pages.dataCount"
      >
      </el-pagination>
    </el-col>

    <!--新增界面-->
    <el-dialog
      :title="editmark == true ? '编辑' : '新增'"
      :visible.sync="FormVisible"
      v-model="FormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="Form"
        label-width="100px"
        ref="Form"
        style="max-width: 700px"
        :rules="FormRules"
      >
        <el-form-item label="勋章类型：">
          <div v-if="Form.medalType == '1'">学习勋章</div>
          <div v-if="Form.medalType == '2'">消费勋章</div>
          <div v-if="Form.medalType == '3'">拉新勋章</div>
          <div v-if="Form.medalType == '4'">分享勋章</div>
          <div v-if="Form.medalType == '5'">赚钱勋章</div>
          <div v-if="Form.medalType == '6'">答题勋章</div>
        </el-form-item>
        <el-form-item label="勋章等级：" prop="grade">
          <el-input
            v-model="Form.grade"
            auto-complete="off"
            placeholder="请输入勋章等级："
          ></el-input>
        </el-form-item>
        <el-form-item label="勋章名称: "  prop="medalName">
          <el-input
            v-model="Form.medalName"
            auto-complete="off"
            placeholder="请输入勋章名称："
          ></el-input>
        </el-form-item>
        <el-form-item label="获取条件: " prop="conditionValue">
          <el-input
            v-model="Form.conditionValue"
            auto-complete="off"
            placeholder="请输入"
            style="width: 250px"
          ></el-input>
          <span v-if="filters.medalType == 1"> 分钟</span>
          <span v-if="filters.medalType == 2"> 元</span>
          <span v-if="filters.medalType == 3"> 个</span>
          <span v-if="filters.medalType == 4"> 次</span>
          <span v-if="filters.medalType == 5"> 元</span>
          <span v-if="filters.medalType == 6"> 个</span>
        </el-form-item>

        <el-form-item label="材质: "  prop="rankTexture">
          <el-input
            v-model="Form.rankTexture"
            auto-complete="off"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="图片: " prop="cityId">
          <el-upload
            class="avatar-uploader"
            :action="uploadUrl"
            :headers="headers"
            :on-success="handleImageSuccess"
            :before-upload="beforeUpload"
          >
            <img
              v-if="Form.medalImgUrl"
              :src="Form.medalImgUrl"
              class="avatar"       
            />

            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
           
          </el-upload>
           <span  style="color:red;cursor: pointer;" v-if="Form.medalImgUrl" @click="delPicture">替换图片</span>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click.native="FormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="FormSubmit"
          :loading="listLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import {
  uploadMedalImg,
  getMedalListApi,
  addMedalApi,
  editMedalApi,
  delMedalApi,
} from "../../api/api";

export default {
  components: { Toolbar },
  name: "MedalManager",
  data() {
    return {
      fileList: [], // 【新增】用于存储当前上传的文件列表
      filters: {
        medalType: "1",
      },
      // 按钮列表
      buttonList: [],
      // 勋章列表数据（初始化与图片一致）
      tableData: [],
      //弹窗
      FormVisible: false,
      editmark: false,
      // 图片上传地址
      uploadUrl: "",
      // 选中行数据
      currentRow: null,
      listLoading: false,
      //关于分页的obj
      pages: {
        pageSize: 20, //默认每页条数
        pageArr: [10, 20, 30, 40], //默认每页条数选择
        pageIndex: 1, //默认进入页
        dataCount: 20, //默认总页数
      },
      Form: {
        medalType: "1",
        grade: "",
        medalName: "",
        conditionValue: "",
        rankTexture: "",
        medalImgUrl: "",
        medalGifUrl: "1",
      },
      FormRules: {
        grade: [{ required: true, message: "请输入勋章等级", trigger: "blur" }],
        medalName: [
          { required: true, message: "请选择勋章名称", trigger: "blur" },
        ],
        conditionValue: [
          { required: true, message: "请输入获取条件", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    // 请求头（带token）
    headers() {
      return {
        Authorization: "Bearer " + this.getToken(),
      };
    },
  },
  methods: {
     // 【新增】查询按钮调用的方法
    handleSearch() {
      this.pages.pageIndex = 1;
      this.getList();
    },
    handleClick(e) {
      this.filters.medalType = e.name;
      this.getList();
    },
    // 分页
    handleCurrentChange(val) {
      this.pages.pageIndex = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pages.pageSize = val;
      this.getList();
    },
    // 获取token
    getToken() {
      return localStorage.getItem("Token");
    },
    // 选中表格行
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    // apply改变this指向
    callFunction(item) {
      this[item.func].apply(this, item);
    },

    // 图片上传成功回调
    handleImageSuccess(res, file, fileList) {
      console.log("fileList", fileList);
      this.fileList = fileList;
      if (res.success) {
        this.Form.medalImgUrl = res.response.weburl || "";
        this.$message.success("图片上传成功");
      } else {
        this.$message.error(res.data.message);
      }
    },
    // 图片上传前校验
    beforeUpload(file) {
      const isImage = file.type.startsWith("image/");
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isImage) {
        this.$message.error("上传文件只能是图片格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isImage && isLt2M;
    },

    delPicture(){
      console.log('delPic')
      this.Form.medalImgUrl=''
    },

    // 获取勋章列表（实际项目中调用接口）
    getList() {
      let params = {
        ...this.filters,
        pageIndex: this.pages.pageIndex,
        pageSize: this.pages.pageSize,
      };
      getMedalListApi(params).then((res) => {
        if (res.data.success) {
          this.tableData = res.data.response.data;
          this.pages.dataCount = res.data.response.dataCount;
        }
      });
    },
    handleAdd() {
      // 等待 DOM 渲染完成再调用 clearValidate
      this.$nextTick(() => {
        if (this.$refs.Form) {
          this.$refs.Form.clearValidate();
        }
      });
      this.Form = {
        medalType: this.filters.medalType,
        grade: "",
        medalName: "",
        conditionValue: "",
        rankTexture: "",
        medalImgUrl: "",
        medalGifUrl: "1",
      };
      this.editmark = false;
      this.FormVisible = true;
    },

    handleEdit() {
      if (!this.currentRow) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });
        return;
      }
      // 等待 DOM 渲染完成再调用 clearValidate
      this.$nextTick(() => {
        if (this.$refs.Form) {
          this.$refs.Form.clearValidate();
        }
      });
      this.editmark = true;
      // 深拷贝一下
      this.Form = {
        id: this.currentRow.id,
        medalType: this.currentRow.medalType,
        grade: this.currentRow.grade,
        medalName: this.currentRow.medalName,
        conditionValue: this.currentRow.conditionValue,
        rankTexture: this.currentRow.rankTexture,
        medalImgUrl: this.currentRow.medalImgUrl,
        medalGifUrl: "1",
      };
      // 如果为消费勋章的时候,才除100
      if(this.filters.medalType=="2"){
          this.Form.conditionValue = this.currentRow.conditionValue/100
      }
      this.FormVisible = true;
    },

    //提交新增表单
    FormSubmit() {
      this.$refs.Form.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.listLoading = true;
           // 如果为消费勋章的时候,才乘100
            if(this.filters.medalType=="2"){
                this.Form.conditionValue =  Math.round(this.Form.conditionValue * 100)
            }
            let params = {
              ...this.Form
            };

            if (this.editmark) {
              editMedalApi(params).then((res) => {
                if (res.data.success) {
                  this.listLoading = false;
                  this.$message({
                    message: res.data.message,
                    type: "success",
                  });
                  this.$refs["Form"].clearValidate();
                  this.FormVisible = false;
                  this.getList();
                } else {
                  this.listLoading = false;
                  this.$message({
                    message: res.data.message,
                    type: "error",
                  });
                }
              });
            } else {
              addMedalApi(params).then((res) => {
                if (res.data.success) {
                  this.listLoading = false;
                  this.$message({
                    message: res.data.message,
                    type: "success",
                  });
                  this.$refs["Form"].clearValidate();
                  this.FormVisible = false;
                  this.handleSearch();
                } else {
                  this.listLoading = false;
                  this.$message({
                    message: res.data.message,
                    type: "error",
                  });
                }
              });
            }
          });
        }
      });
    },

    handleDel() {
      if (!this.currentRow) {
        this.$message({
          message: "请选择要删除的的一行数据！",
          type: "error",
        });
        return;
      }
      this.$confirm("确认删除吗？", "提示", {}).then(() => {
        this.listLoading = true;
        let params = {
          Id: this.currentRow.id,
        };

        delMedalApi(params).then((res) => {
          if (res.data.success) {
            this.listLoading = false;
            this.$message({
              message: res.data.message,
              type: "success",
            });
             // 👇👇👇【核心逻辑开始】👇👇👇
            // 1. 获取当前页展示的数据条数
            const currentPageSize = this.tableData.length;
            
            // 2. 判断：如果是当前页的最后一条数据 (长度为1) 且 不是第一页 (pageIndex > 1)
            if (currentPageSize === 1 && this.pages.pageIndex > 1) {
              // 页码减 1，跳回上一页
              this.pages.pageIndex--;
            }
            // 👆👆👆【核心逻辑结束】👆👆
            this.getList();
            this.$refs["Form"].clearValidate();
            this.FormVisible = false;
          } else {
            this.listLoading = false;
            this.$message({
              message: res.data.message,
              type: "error",
            });
          }
        });
      });
    },

    jumpRevisionHistory(row) {
      this.$router.push({
        path: "/MedalManagementRevisionHistory",
        query: {
          medalType: row.medalType,
          id: row.id,
        },
      });
    },
  },
  mounted() {
    // 初始化按钮列表
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    // 初始化上传地址
    this.uploadUrl = uploadMedalImg;
    this.getList();
  },
};
</script>

<style lang="stylus" scoped>
.medal-manager {
  padding: 20px;
}

.avatar-uploader {
  width: 178px;
  height: 178px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c8c8c;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
   object-fit: contain;
}
.pageBar {
  margin-top: 15px;
}


/* 👇👇👇 新增的样式开始 👇👇👇 */
.custom-padding-table
  ::v-deep .el-table__cell
    /* 上下内边距，根据需要调整数值，默认通常是 8px 或 10px */
    padding-top: 16px
    padding-bottom: 16px
    
  /* 如果上面的写法在某些构建环境下不生效，可以尝试加 !important 强制覆盖 */
  ::v-deep td.el-table__cell
    padding-top: 16px !important
    padding-bottom: 16px !important
/* 👆👆👆 新增的样式结束 👆👆👆 */

</style>